function appendQueryParams(target: URLSearchParams, value: string) {
  const trimmed = value.trim();
  if (!trimmed) return;

  const hashIndex = trimmed.indexOf("#");
  const withoutHash = hashIndex >= 0 ? trimmed.slice(0, hashIndex) : trimmed;
  const query = withoutHash.startsWith("?") ? withoutHash.slice(1) : withoutHash;

  new URLSearchParams(query).forEach((paramValue, key) => {
    target.append(key, paramValue);
  });
}

function hashQuery(hash: string) {
  const queryIndex = hash.indexOf("?");
  if (queryIndex < 0) return "";
  return hash.slice(queryIndex + 1);
}

export function hashAnchorId(hash: string) {
  const anchor = hash.replace(/^#/, "").split("?", 1)[0];
  try {
    return decodeURIComponent(anchor);
  } catch {
    return anchor;
  }
}

export function paramsFromSearchAndHash(search?: string, hash?: string) {
  const hasWindow = typeof window !== "undefined";
  const params = new URLSearchParams();
  const currentSearch = search ?? (hasWindow ? window.location.search : "");
  const currentHash = hash ?? (hasWindow ? window.location.hash : "");

  appendQueryParams(params, currentSearch);
  appendQueryParams(params, hashQuery(currentHash));

  return params;
}

export function firstNonEmptyParam(params: URLSearchParams, key: string) {
  return params.getAll(key).find((value) => value.trim() !== "") ?? null;
}
